import {
  addUserLoggedEventListener,
  addUserLogoutEventListener,
  addAuthenticationBootstrappedEventListener,
} from "./main/user-area/utils/listeners";
import { showLoginModal } from "./main/user-area/utils/loginModal";
import { showTmPlusFiltersModal } from "./main/enem-exercises/utils/tmplus-filters-modal";

import "./main/enem-exercises";

const desktopBreakpoint = 1024;
const filterDialogState = {
  open: false,
};
const filterRestrictions = {
  active: false,
  premium: {
    active: true,
    fields: ["unique_questions", "has_explanation"],
  },
  logged: {
    active: true,
    fields: ["answer_status"],
  },
};

function setFilterRestrictions(restriction, active) {
  filterRestrictions[restriction].active = active;

  if (active) {
    filterRestrictions[restriction].fields.forEach((field) => {
      const inputs = document.querySelectorAll(`input[name="${field}"]`);
      inputs.forEach((input) => {
        input.checked = false;
      });
    });
  }
}

function openFilterDialog() {
  const filterDialog = document.getElementById("filterDialog");
  filterDialog.showModal();
  filterDialogState.open = true;
}

function closeFilterDialog() {
  const filterDialog = document.getElementById("filterDialog");
  filterDialog.close();
  filterDialogState.open = false;
}

function setupFilterDialog() {
  const filterDialog = document.getElementById("filterDialog");
  const filterTrigger = document.getElementById("filterTrigger");
  const closeDialog = document.getElementById("closeDialog");

  if (!filterDialog || !filterTrigger) return;

  // Show filter dialog on mobile
  filterTrigger.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    openFilterDialog();
  });

  // Close dialog on mobile - click handler for close button
  if (closeDialog) {
    closeDialog.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeFilterDialog();
    });
  }

  // Backdrop click handler
  filterDialog.addEventListener("click", (e) => {
    if (
      filterDialogState.open &&
      e.target === filterDialog &&
      window.innerWidth < desktopBreakpoint
    ) {
      closeFilterDialog();
    }
  });

  // Handle automatic showing of dialog on desktop
  const handleResize = () => {
    if (window.innerWidth >= desktopBreakpoint && filterDialogState.open) {
      // On desktop, make sure dialog is "open" but not as a modal
      closeFilterDialog();
      filterDialog.setAttribute("open", "");
    } else if (
      window.innerWidth < desktopBreakpoint &&
      filterDialog.hasAttribute("open") &&
      !filterDialogState.open
    ) {
      // On mobile, remove "open" if it's not actually open as a modal
      filterDialog.removeAttribute("open");
      closeFilterDialog();
    }
  };

  // Initial check and listen for window resize
  handleResize();
  window.addEventListener("resize", handleResize);
}

function setupFilterFormController() {
  const clearFiltersButton = document.querySelector(
    "button.enem-exercises-filter-actions-button--clear"
  );
  const form = document.querySelector("form.enem-exercises-filter-form");

  const subjectInput = document.getElementById("subject-select");
  const subjectCategoriesInput = document.getElementById(
    "subject-categories-select"
  );
  const difficultyInput = document.getElementById("difficulty-select");
  const uniqueQuestionsInput = document.querySelector(
    'input[name="unique_questions"]'
  );
  const hasExplanationInput = document.querySelector(
    'input[name="has_explanation"]'
  );
  const statusUnansweredInput = document.querySelector(
    'input[name="answer_status"][value="1"]'
  );
  const statusAnsweredInput = document.querySelector(
    'input[name="answer_status"][value="2"]'
  );
  const statusCorrectInput = document.querySelector(
    'input[name="answer_status"][value="3"]'
  );
  const statusIncorrectInput = document.querySelector(
    'input[name="answer_status"][value="4"]'
  );

  const appliedFilters = {
    subject: subjectInput.selected,
    subject_categories: subjectCategoriesInput.selected,
    difficulty: difficultyInput.selected,
    unique_questions: uniqueQuestionsInput.checked,
    has_explanation: hasExplanationInput.checked,
    answer_status:
      (statusUnansweredInput.checked && statusUnansweredInput.value) ||
      (statusAnsweredInput.checked && statusAnsweredInput.value) ||
      (statusCorrectInput.checked && statusCorrectInput.value) ||
      (statusIncorrectInput.checked && statusIncorrectInput.value),
  };

  function resetAppliedFilters() {
    const inputs = Object.keys(appliedFilters);
    inputs.forEach((input) => {
      updateAppliedFilters(input, false);
    });
  }

  function updateAppliedFilters(name, value) {
    appliedFilters[name] = value;
    const hasFiltersApplied = Object.values(appliedFilters).some(
      (value) => !!value
    );
    clearFiltersButton.classList.toggle("hidden", !hasFiltersApplied);
  }

  function handleFormSubmit() {
    const formData = new FormData(form);
    const url = new URL(window.location.origin);
    url.pathname = "/exercicios-enem/";

    const selectedSubject = formData.get("subject");
    if (selectedSubject && appliedFilters.subject) {
      const [_, subjectSlug] = selectedSubject.split("|");
      url.pathname = `${url.pathname}${subjectSlug}/`;
    }

    formData.delete("subject");
    formData.forEach((value, key) => {
      if (appliedFilters[key]) {
        url.searchParams.set(key, value)
      }
    });

    if (window.innerWidth < desktopBreakpoint && filterDialogState.open) {
      closeFilterDialog();
    }

    if (window.location.href !== url.toString()) {
      window.location.href = url.toString();
    }
  }

  clearFiltersButton.addEventListener("click", () => {
    form.reset();
    uniqueQuestionsInput.checked = false;
    hasExplanationInput.checked = false;
    statusUnansweredInput.checked = false;
    statusAnsweredInput.checked = false;
    statusCorrectInput.checked = false;
    statusIncorrectInput.checked = false;
    resetAppliedFilters();
    handleFormSubmit();
  });

  function onSelectInputChanged(e) {
    if (!e.detail) return;
    const { name, value } = e.detail;

    if (typeof value === "string") {
      return updateAppliedFilters(name, !!value);
    } else if (typeof value === "object") {
      return updateAppliedFilters(name, value.length > 0);
    }

    return updateAppliedFilters(name, false);
  }

  subjectInput.addEventListener("initialized", onSelectInputChanged);
  subjectInput.addEventListener("change", async (e) => {
    onSelectInputChanged(e);
    if (!e.detail) return;
    updateAppliedFilters("subject_categories", false);
    const selectedSubject = e.detail.value;

    subjectCategoriesInput.toggleAttribute("disabled", true);
    subjectCategoriesInput.options = JSON.stringify([]);
    subjectCategoriesInput.disabledMessage =
      "Selecione uma disciplina primeiro";
    if (!selectedSubject) return;

    subjectCategoriesInput.toggleAttribute("data-loading", true);
    const [subjectId, _] = selectedSubject.split("|");
    const response = await fetch(
      `/api/exercises/?action=subject-chapters&subject_id=${subjectId}`
    );
    if (!response.ok) {
      subjectCategoriesInput.toggleAttribute("data-loading", false);
      subjectCategoriesInput.disabledMessage =
        "Não foi possível carregar as categorias";
      return;
    }

    const {
      data: { subjectCategoryOptions },
    } = await response.json();

    subjectCategoriesInput.options = JSON.stringify(subjectCategoryOptions);
    subjectCategoriesInput.toggleAttribute("data-loading", false);
    subjectCategoriesInput.disabledMessage =
      subjectCategoryOptions.length > 0 ? "" : "Nenhum assunto disponível";
    subjectCategoriesInput.toggleAttribute(
      "disabled",
      subjectCategoryOptions.length === 0
    );
  });

  subjectCategoriesInput.addEventListener("initialized", onSelectInputChanged);
  subjectCategoriesInput.addEventListener("change", onSelectInputChanged);

  difficultyInput.addEventListener("initialized", onSelectInputChanged);
  difficultyInput.addEventListener("change", onSelectInputChanged);

  function onCheckboxInputChanged(e) {
    const { name, checked } = e.target;
    updateAppliedFilters(name, checked);
  }

  function onRadioInputChanged(e) {
    const { name, value, checked } = e.target;
    updateAppliedFilters(name, checked ? value : false);
  }

  function checkIfRestrictionsAreActive(e) {
    if (!filterRestrictions.active) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    return true;
  }

  function showLoginModalIfRestricted(e) {
    if (!checkIfRestrictionsAreActive(e)) return false;
    
    const inputName = e.target.name;
    const isRestricted = filterRestrictions.logged.active && filterRestrictions.logged.fields.includes(inputName);
    if (isRestricted) {
      e.preventDefault();
      e.stopPropagation();
      let callback = undefined;

      if (filterDialogState.open) {
        closeFilterDialog();
        callback = openFilterDialog;
      }

      showLoginModal("Faça login para liberar mais filtros", callback);
      return false;
    }

    return true;
  }

  function showPremiumModalIfRestricted(e) {
    if (!checkIfRestrictionsAreActive(e)) return;

    const inputName = e.target.name;
    const isRestricted = filterRestrictions.premium.active && filterRestrictions.premium.fields.includes(inputName);
    if (isRestricted) {
      e.preventDefault();
      e.stopPropagation();
      let callback = undefined;

      if (filterDialogState.open) {
        closeFilterDialog();
        callback = openFilterDialog;
      }

      showTmPlusFiltersModal(callback);
      return false;
    }

    return true;
  }

  function toggleQuestionStatusRadioInput(e, preventDefault = false) {
    const { name, value, checked } = e.target;
    if (checked && value === appliedFilters.answer_status) {
      if (preventDefault) {
        e.preventDefault();
      }
      e.target.checked = false;
      updateAppliedFilters(name, false);
    }
  }

  function handleQuestionStatusRadioInputKeydown(e) {
    if (e.code !== "Space") return;
    toggleQuestionStatusRadioInput(e, true);
  }

  function onQuestionStatusRadioInputClick(e) {
    if (showLoginModalIfRestricted(e)) {
      toggleQuestionStatusRadioInput(e);
    }
  }

  uniqueQuestionsInput.addEventListener("change", onCheckboxInputChanged);
  uniqueQuestionsInput.addEventListener("click", showPremiumModalIfRestricted);

  hasExplanationInput.addEventListener("change", onCheckboxInputChanged);
  hasExplanationInput.addEventListener("click", showPremiumModalIfRestricted);

  statusUnansweredInput.addEventListener("change", onRadioInputChanged);
  statusUnansweredInput.addEventListener(
    "click",
    onQuestionStatusRadioInputClick
  );
  statusUnansweredInput.addEventListener(
    "keydown",
    handleQuestionStatusRadioInputKeydown
  );

  statusAnsweredInput.addEventListener("change", onRadioInputChanged);
  statusAnsweredInput.addEventListener(
    "click",
    onQuestionStatusRadioInputClick
  );
  statusAnsweredInput.addEventListener(
    "keydown",
    handleQuestionStatusRadioInputKeydown
  );

  statusCorrectInput.addEventListener("change", onRadioInputChanged);
  statusCorrectInput.addEventListener("click", onQuestionStatusRadioInputClick);
  statusCorrectInput.addEventListener(
    "keydown",
    handleQuestionStatusRadioInputKeydown
  );

  statusIncorrectInput.addEventListener("change", onRadioInputChanged);
  statusIncorrectInput.addEventListener(
    "click",
    onQuestionStatusRadioInputClick
  );
  statusIncorrectInput.addEventListener(
    "keydown",
    handleQuestionStatusRadioInputKeydown
  );

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    handleFormSubmit();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setupFilterDialog();
  setupFilterFormController();
});

addUserLoggedEventListener((event) => {
  const { isPremium, uuid } = event.detail;
  setFilterRestrictions("logged", !!!uuid);
  setFilterRestrictions("premium", !(!!uuid && isPremium));
});

addUserLogoutEventListener(() => {
  setFilterRestrictions("logged", true);
  setFilterRestrictions("premium", true);
});

addAuthenticationBootstrappedEventListener(() => {
  filterRestrictions.active = true;
});
